/** PWA install gate modal (Vercel Blob). */
export const PWA_INSTALL_MODAL_BG_URL =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/main/install-app-modal-bg.webp'

export const PWA_INSTALL_APP_BTN_URL =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/main/install-app-btn.webp'

export const PWA_INSTALL_APP_ICO_URL =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/main/install-app-ico.webp'

export const PWA_CONTINUE_BROWSER_BTN_URL =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/main/continue-browser-btn.webp'

export const PWA_CONTINUE_BROWSER_ICO_URL =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/main/continue-browser-ico.webp'

/** Local logo for PWA install modal (`public/assets/logo.png`). */
export const PWA_INSTALL_MODAL_LOGO_PUBLIC_PATH = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/logo.png'

/** Blob art only; logo is served from `public/`. */
export const PWA_INSTALL_MODAL_PRELOAD_URLS: readonly string[] = [
  PWA_INSTALL_MODAL_BG_URL,
  PWA_INSTALL_APP_BTN_URL,
  PWA_INSTALL_APP_ICO_URL,
  PWA_CONTINUE_BROWSER_BTN_URL,
  PWA_CONTINUE_BROWSER_ICO_URL,
]
